var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.934 205.868C162.022 205.868 205.868 162.022 205.868 107.934C205.868 53.8466 162.022 10 107.934 10C53.8466 10 10 53.8466 10 107.934C10 162.022 53.8466 205.868 107.934 205.868Z",
    stroke: "black",
    strokeWidth: 19.5868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2447 17.3451C117.042 76.3994 133.201 109.599 152.886 190.884M177.761 40.2617C141.33 82.863 90.208 95.6924 12.4482 97.5532M203.42 116.161C169.143 107.053 138.49 108.13 115.867 116.161C90.5997 125.171 66.8017 144.17 43.0037 178.055",
    stroke: "black",
    strokeWidth: 19.5868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbble);
export default __webpack_public_path__ + "static/media/dribbble.9968b645190a66d2d92a281bbd3cbce4.svg";
export { ForwardRef as ReactComponent };